import { Dialog } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import CenteredModal from "./CenteredModal";
type ConfirmationModalProps = {
  isOpen: boolean;
  onPreviewClick: () => void;
  closeModal: () => void;
  btnText: string;
};
export default function CancelStudentModal(props: ConfirmationModalProps) {
  const { isOpen, onPreviewClick, btnText, closeModal } = props;

  const LocalBasePath = "page.candidate.dashboard.schedule";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <CenteredModal setOpen={closeModal} open={isOpen}>
      <Dialog.Panel className="p-2  overflow-hidden  bg-white  w-80">
        <div>
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-teal-50">
            <CheckCircleIcon
              className="h-6 w-6 text-teal-700"
              aria-hidden="true"
            />
          </div>
          <div className="mt-3 text-center">
            <p className="text-base text-gray-500">
              {t("successfullyConfirm")}
            </p>
          </div>
        </div>
        <div className="mt-3">
          <button
            type="button"
            className="mx-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
            onClick={() => onPreviewClick()}
          >
            {t(btnText)}
          </button>
        </div>
      </Dialog.Panel>
    </CenteredModal>
  );
}
